<template>
    <div class="">
        <div class="d-flex justify-content-between">
            <div class="p-2">
                <label><slot></slot></label>
            </div>

            <p class="p-2" v-if="!active">{{ t('notificationSchedule-unavailable') }}</p>

            <div class="p-2">
                <a
                    class="text-secondary p-2"
                    href="#"
                    :title="t('notificationSchedule-add')"
                    @click.prevent="addTimeLine()"
                >
                    <span class="fa fa-plus 4x"></span>
                </a>
                <a
                    class="text-secondary p-2"
                    href="#"
                    :title="t('notificationSchedule-copy')"
                    @click.prevent="copyTimeLine()"
                >
                    <span class="fa fa-clone 2x"></span>
                </a>
            </div>
        </div>

        <div
            class="time ms-auto d-flex align-items-center jusify-content-sm-end offset-md-1"
            v-for="(line, key) in time"
            :key="key"
        >
            <input
                type="time"
                class="form-control col-12 col-md-5"
                v-model="line[0]"
            />
            <input
                type="time"
                class="m-md-1 mt-2 mt-md-0 form-control col-12 col-md-5"
                v-model="line[1]"
            />
            <a
                class="text-secondary cursor-pointer m-2"
                href="#"
                :title="t('notificationSchedule-remove')"
                @click.prevent="removeTimeLine(key)"
            >
                <span class="fa fa-trash"></span>
            </a>
        </div>
        <hr />
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Array,
            default: () => [["00:00", "23:59"]],
        },
    },
    data() {
        return {
            time: [],
            active: true,
        };
    },
    watch: {
        value(oldValue, newValue) {
            if (oldValue !== newValue) {
                this.active = !!this.value?.length;
                this.time = this.value;
            }
        },
        active() {
            if (this.active) {
                if (this.value && this.value?.length) {
                    return (this.time = this.value);
                }
                return this.addTimeLine();
            }
            this.time = [];
        },
        time() {
            this.$emit("input", this.time);
        },
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        checkIncludesTime(time) {
            return JSON.stringify(this.time).includes(JSON.stringify(time));
        },
        addTimeLine() {
            const defaultValue = [
                ["00:00", "23:59"],
                ["", ""],
            ];
            if (this.time?.length > 0) {
                return this.time.push(
                    this.checkIncludesTime(defaultValue[0])
                        ? defaultValue[1]
                        : defaultValue[0],
                );
            }
            this.time = [defaultValue[0]];
        },
        copyTimeLine() {
            this.$emit("copy", this.time);
        },
        removeTimeLine(key) {
            this.time.splice(key, 1);
            if (!this.time?.length || this.time?.length === 0) {
                this.active = false;
            }
        },
    },
    mounted() {
        this.time = this.value;
        if (!this.value || this.value?.length == 0) {
            this.active = false;
        }
    },
};
</script>
